import axios from "axios";

const api = axios.create({
  baseURL: "http://api.righttracklb.com/",
});

export default api;